"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = void 0;
var _react = _interopRequireWildcard(require("react"));
var _downshift = require("downshift");
var _bind = _interopRequireDefault(require("classnames/bind"));
var _icon = require("../icon");
var _excluded = ["selected", "label", "items", "onChange", "singleMode", "compact", "className"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var cx = _bind["default"].bind();
var Select = exports.Select = function Select(_ref) {
  var _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? [] : _ref$selected,
    label = _ref.label,
    items = _ref.items,
    onChange = _ref.onChange,
    _ref$singleMode = _ref.singleMode,
    singleMode = _ref$singleMode === void 0 ? false : _ref$singleMode,
    _ref$compact = _ref.compact,
    compact = _ref$compact === void 0 ? false : _ref$compact,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  var _useState3 = (0, _react.useState)(selected),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedItems = _useState4[0],
    setSelectedItems = _useState4[1];
  (0, _react.useEffect)(function () {
    if (JSON.stringify(selected) !== JSON.stringify(selectedItems)) {
      setSelectedItems(selected);
    }
  }, [selectedItems, onChange, selected]);
  var getItemLabel = function getItemLabel(item) {
    return _typeof(item) === "object" && item !== null ? item.label : item;
  };
  var isItemSelected = function isItemSelected(item) {
    return selectedItems.some(function (selectedItem) {
      return _typeof(item) === "object" ? selectedItem.value === item.value : selectedItem === item;
    });
  };
  var _useMultipleSelection = (0, _downshift.useMultipleSelection)({
      selectedItems: selectedItems,
      onStateChange: function onStateChange(_ref2) {
        var newSelectedItems = _ref2.selectedItems,
          type = _ref2.type;
        switch (type) {
          case _downshift.useMultipleSelection.stateChangeTypes.SelectedItemKeyDownBackspace:
          case _downshift.useMultipleSelection.stateChangeTypes.SelectedItemKeyDownDelete:
          case _downshift.useMultipleSelection.stateChangeTypes.DropdownKeyDownBackspace:
          case _downshift.useMultipleSelection.stateChangeTypes.FunctionRemoveSelectedItem:
            setSelectedItems(newSelectedItems);
            break;
          default:
            break;
        }
      }
    }),
    getDropdownProps = _useMultipleSelection.getDropdownProps;
  var _useCombobox = (0, _downshift.useCombobox)({
      items: items,
      selectedItem: null,
      inputValue: inputValue,
      stateReducer: function stateReducer(state, actionAndChanges) {
        var changes = actionAndChanges.changes,
          type = actionAndChanges.type;
        switch (type) {
          case _downshift.useCombobox.stateChangeTypes.InputKeyDownEnter:
          case _downshift.useCombobox.stateChangeTypes.ItemClick:
            return _objectSpread(_objectSpread({}, changes), {}, {
              isOpen: true // keep the menu open after selection.
            });
          default:
            return changes;
        }
      },
      onStateChange: function onStateChange(_ref3) {
        var newInputValue = _ref3.inputValue,
          type = _ref3.type,
          newSelectedItem = _ref3.selectedItem;
        switch (type) {
          case _downshift.useCombobox.stateChangeTypes.InputKeyDownEnter:
          case _downshift.useCombobox.stateChangeTypes.ItemClick:
          case _downshift.useCombobox.stateChangeTypes.InputBlur:
            {
              if (!newSelectedItem) return;
              if (singleMode) {
                var newSelected = selectedItems.includes(newSelectedItem) ? [] : [newSelectedItem];
                setSelectedItems(newSelected);
                return onChange(newSelected);
              }
              var newSelectedItems = selectedItems.includes(newSelectedItem) ? selectedItems.filter(function (item) {
                return _typeof(item) === "object" ? item.value !== newSelectedItem.value : item !== newSelectedItem;
              }) : Array.from(new Set([].concat(_toConsumableArray(selectedItems), [newSelectedItem])));
              setSelectedItems(newSelectedItems);
              onChange(newSelectedItems);
              return setInputValue("");
            }
          case _downshift.useCombobox.stateChangeTypes.InputChange:
            setInputValue(newInputValue);
            break;
          default:
            break;
        }
      }
    }),
    isOpen = _useCombobox.isOpen,
    getLabelProps = _useCombobox.getLabelProps,
    getToggleButtonProps = _useCombobox.getToggleButtonProps,
    getMenuProps = _useCombobox.getMenuProps,
    getInputProps = _useCombobox.getInputProps,
    highlightedIndex = _useCombobox.highlightedIndex,
    getItemProps = _useCombobox.getItemProps;
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, rest, {
    className: "".concat(className, " relative")
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col gap-1"
  }, /*#__PURE__*/_react["default"].createElement("label", _extends({}, getLabelProps(), {
    className: "text-[13px] text-[#282F44]"
  }), label), /*#__PURE__*/_react["default"].createElement("div", {
    className: "border border-[#C6CCE8] hover:border-[#A1A7C2] rounded-lg border-2 mr-[8px] bg-white inline-flex gap-4 items-center flex-wrap ".concat(compact ? "text-xs px-x-small" : "text-base px-medium py-regular")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex gap-0.5 grow"
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({
    placeholder: selectedItems.length ? selectedItems.map(getItemLabel).join(", ") : "Select one or more",
    className: "w-full placeholder-shown:text-ellipsis outline-none placeholder:text-[#282F44] placeholder:focus:text-[#C6CCE8]"
  }, getInputProps(getDropdownProps({
    preventKeyAction: isOpen
  })))), Boolean(selectedItems.length) && !singleMode && /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      setSelectedItems([]);
      onChange([]);
    }
  }, /*#__PURE__*/_react["default"].createElement(_icon.Icon, {
    glyphName: "close",
    className: "text-slate-600"
  })), /*#__PURE__*/_react["default"].createElement("button", _extends({
    "aria-label": "toggle menu",
    type: "button"
  }, getToggleButtonProps()), /*#__PURE__*/_react["default"].createElement(_icon.Icon, {
    glyphName: isOpen ? "expand_less" : "expand_more",
    className: "text-slate-600 ".concat(compact ? "!text-sm" : "!text-base")
  }))))), /*#__PURE__*/_react["default"].createElement("ul", _extends({
    className: "w-full absolute bg-white mt-1 max-h-80 overflow-x-scroll p-[8px] z-10 rounded-lg shadow-[0_8px_8px_-4px_rgba(0,0,0,0.08),_0px_0px_8px_2px_rgba(0,0,0,0.08)] no-scrollbar ".concat(!(isOpen && items.length) && "hidden")
  }, getMenuProps()), isOpen && items.map(function (item, index) {
    var itemLabel = getItemLabel(item);
    var itemIsSelected = isItemSelected(item);
    var itemMatchesSearch = inputValue !== null && inputValue !== void 0 && inputValue.length ? itemLabel.toLowerCase().includes(inputValue.toLowerCase()) : true;
    return /*#__PURE__*/_react["default"].createElement("li", _extends({
      className: cx(highlightedIndex === index && "bg-[#EFF6FF]", itemIsSelected && "bg-[#EFF6FF]", !itemMatchesSearch && "hidden", "py-[8px] px-[6px] mb-[4px] flex flex-col rounded-md text-[#282F44]"),
      key: _typeof(item) === "object" ? item.value : item
    }, getItemProps({
      item: item,
      index: index
    })), /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-sm text-gray-700 flex justify-between"
    }, /*#__PURE__*/_react["default"].createElement("span", null, itemLabel), " ", /*#__PURE__*/_react["default"].createElement("span", null, itemIsSelected && /*#__PURE__*/_react["default"].createElement(_icon.Icon, {
      glyphName: "check",
      className: "text-slate-800 ".concat(compact ? "!text-sm" : "!text-base")
    }))));
  })));
};